import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { OperationResult } from '@tb/auth';
import { Subscription } from 'rxjs';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { CountryService } from 'src/app/core/services/country.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LoginService } from 'src/app/core/services/login.service';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { PdfCreatorService } from 'src/app/core/services/pdfcreator.service';
import { PrivacyAgreementService } from 'src/app/core/services/privacy-agreement.service';
import { ProductService } from 'src/app/core/services/product.service';
import { RolesService } from 'src/app/core/services/roles.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Customer } from 'src/app/model/customer';
import { Feature, OptionInfo } from 'src/app/model/feature';
import { IndustryProductID } from 'src/app/model/industry';
import { AppSubscription, Mode } from 'src/app/model/subscription';
import { InputDialogComponent } from 'src/app/store/dialogs/input-dialog/input-dialog.component';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';
@Component({
    selector: 'ms-magoweb-management',
    templateUrl: './magoweb-management.component.html',
    styleUrls: ['./magoweb-management.component.scss'],
})
export class MagoWebManagementComponent implements OnInit {
    private subscriptionKey = '';
    private subscriptionDescription = '';
    public edition: string = 'pro';
    public productID: string = IndustryProductID.MW;
    public loading: boolean = false;
    public userchecked = false;
    public selectedFeaturesOptionInfo: OptionInfo[] = [];
    subscriptionNFS = '';
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    public smallScreen: boolean = false;
    public titleIndustry: string;
    public subscription: Subscription;
    public countrySelected: string = 'none';
    public filteredCountableFeatures: Feature[] = [];

    constructor(
        public navigateService: NavigateService,
        public magoWebService: MagoWebService,
        private variable: TranslatedVariables,
        public workFlow: WorkFlowService,
        private router: Router,
        public storeRoleService: StoreRolesService,
        private subscriptionService: SubscriptionService,
        private rolesService: RolesService,
        private loginService: LoginService,
        private activatedRoute: ActivatedRoute,
        private pdfCreatorService: PdfCreatorService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        public loadingService: LoadingService,
        public countryService: CountryService,
        private customerService: CustomerService,
        public privacyAgreementService: PrivacyAgreementService,
        private productService: ProductService
    ) {
        this.magoWebService.edition = this.edition;
        this.countryService.setCountry(this.countrySelected);
    }
    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (!params) return;
            this.subscriptionNFS = params.subscriptionNfs;
            this.magoWebService.subscriptionNfs = this.subscriptionNFS === '1';
        });

        this.getsubscriptionDescription();
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    public navigateToHome() {
        this.navigateService.goToHomePage();
    }
    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
    public show_hide() {
        this.magoWebService.expandSummary = !this.magoWebService.expandSummary;
    }

    async createOrUpdateTestSubscription() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        let opResult: OperationResult = await this.magoWebService.createOrUpdateTestSubscription(this.authorizationProperties.accountName);
        if (!opResult.Result) {
            this.workFlow.showMessage(this.variable.warningTitle, this.variable.errorCreating);
        } else {
            let subInfo = await this.subscriptionService.getSubscriptionsToPromise(
                this.authorizationProperties.accountName,
                opResult.Content
            );
            let subscriptions = subInfo['Content'];
            let subscription: AppSubscription = subscriptions[0];
            let msg = `${opResult.Message}.<br />${this.variable.subcriptionCode}:${subscription.SubscriptionKey},<br /> ${this.variable.subscriptionDescription}:${subscription.Description}`;
            if (this.magoWebService.isModifyStatus) this.workFlow.showMessage(this.variable.messageSubTitle_6, msg);
            else this.workFlow.showMessage(this.variable.messageTitle_5, msg);
            this.rolesService.refreshRoles(this.authorizationProperties.accountName);
            this.magoWebService.Clear();
            this.navigateService.goToHomePage();
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    public async getsubscriptionDescription() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.subscriptionKey = params.subscriptionSelected
                ? atob(params.subscriptionSelected)
                : params.subKey
                ? atob(params.subKey)
                : '';
        });

        if (this.magoWebService.subscriptionNfs) {
            this.subscriptionNFS = "Stai effettuando l'acquisto di una Not For Sale";
            return;
        }
        let languageForCms = this.workFlow.getLanguageForCms();
        let subDescri = await this.subscriptionService.getSubscriptionDescription(this.subscriptionKey);
        if (!this.subscriptionKey || this.subscriptionKey.length == 0) return '';
        this.subscriptionDescription = await this.subscriptionService.getHeaderDescription(subDescri, false, languageForCms);
        this.titleIndustry = this.subscriptionDescription;
    }

    public async generateNFSOrder() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        this.magoWebService.currIndustryPurchInfo.Country = this.magoWebService.countryValue;
        //aggiungo le PL alle countable
        this.magoWebService.CALCountableFeatureSelected.forEach((element) => {
            let exists = this.magoWebService.currIndustryPurchInfo.CountableFeatures.findIndex((x) => x.OptionID == element.OptionID) > -1;
            if (!exists) this.magoWebService.currIndustryPurchInfo.CountableFeatures.push(element);
        });

        this.magoWebService.selectedOptionInfo.forEach((element) => {
            let exists =
                this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex((x) => x.optionID == element.optionID) > -1;
            if (!exists) this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(element);
        });
        let result: OperationResult;
        this.subscription = this.customerService.companyInfo$.subscribe(async (companyInfo) => {
            if (!companyInfo) return;
            let savedMasterData: Customer = new Customer();
            savedMasterData.CompanyName = companyInfo.CompanyName;
            savedMasterData.CompanyCode = companyInfo.CompanyCode;
            this.magoWebService.currIndustryPurchInfo.Customer = savedMasterData;
            this.magoWebService.currIndustryPurchInfo.Customer.CompanyCode = companyInfo.CompanyCode;
            this.magoWebService.currIndustryPurchInfo.Customer.PersonalDataAgreeExt = this.privacyAgreementService.PersonalDataAgreeExt;
            this.magoWebService.currIndustryPurchInfo.Customer.PersonalDataAgreeInt = this.privacyAgreementService.PersonalDataAgreeInt;
            this.magoWebService.currIndustryPurchInfo.Customer.PartnerCode = companyInfo.CompanyCode;
            this.magoWebService.currIndustryPurchInfo.SubscriptionMode = Mode[Mode.rnfs].toString(); //1
            let callFullObj = this.magoWebService.currIndustryPurchInfo.caltypes.find((x) => x.CalType == 1);
            callFullObj.NrCalBuyed = this.magoWebService.totalCalFullNr;
            let authorizationStored = this.loginService.getauthinfo();
            let authorizationProperties = JSON.parse(authorizationStored);
            let gwamAccountEmail = authorizationProperties.accountEmail;
            this.magoWebService.currIndustryPurchInfo.gwamAccountEmail = gwamAccountEmail;
            this.loading = true;
            this.loadingService.setLoading(this.loading);

            result = new OperationResult();
            result.Result = true;
            //TODO CREATE NFS
            result = await this.subscriptionService.createorUpdateSubscriptionNFS(
                this.magoWebService.currIndustryPurchInfo,
                gwamAccountEmail,
                authorizationProperties.accountName,
                this.productService.instanceVersionInfo,
                this.magoWebService.subscriptionNfs ? '1' : '0'
            );
            if (result.Result) {
                this.authorizationStored = this.loginService.getauthinfo();
                this.authorizationProperties = JSON.parse(this.authorizationStored);
                this.rolesService.refreshRoles(this.authorizationProperties.accountName);
                //devo cancellare le righe nel carrello
                this.subscriptionService.selectedIndustries = [];
                //svuoto il customer
                this.customerService.customer = new Customer();
                this.customerService.customer$.next(this.customerService.customer);
                let subkey = result.Content as string;
                this.loading = false;
                this.loadingService.setLoading(this.loading);
                this.router.navigate(['./store/OrderConcluded'], {
                    queryParams: { subscriptionKey: subkey, details: false, productID: this.productID },
                });
            } else {
                this.authorizationStored = this.loginService.getauthinfo();
                this.authorizationProperties = JSON.parse(this.authorizationStored);
                this.rolesService.refreshRoles(this.authorizationProperties.accountName);
                this.loading = false;
                this.loadingService.setLoading(this.loading);
                this.router.navigate(['./store/OrderFailed']);
            }
        });
    }
}
